import React from "react";
import PropTypes from "prop-types";
import Article from "../../entities/article";

function SmallArticleBox({ article, companyName }) {
  const getCompanyName = () => {
    if (companyName) return companyName;
    const pathParts = window.location.pathname.split("/");
    return pathParts[2]; // /companies/:name/2025/summer_children
  };

  const articlePath = companyName
    ? `/companies/${getCompanyName()}/articles/${article.id}`
    : `/articles/${article.id}`;

  const renderCategoryLabels = () =>
    Article.category_labels().map((category) => {
      if (article[category]) {
        const className = `p_icon ${Article.class_name(category)}`;
        return (
          <li key={category} className={className}>
            {article.category_names(category)}
          </li>
        );
      }
      return null;
    });

  return (
    <article className="m_smallArticleList">
      <a href={articlePath}>
        {article.main_pic_url && (
          <img
            src={article.small_pic_url || article.main_pic_url}
            alt={article.title}
            width="75"
            height="75"
          />
        )}
        <div className="mainInfo">
          <span className="u_font11">{article.user_name()}</span>
          <h5 className="smallArticleTitle">{article.title}</h5>
        </div>
        <ul>{renderCategoryLabels()}</ul>
      </a>
    </article>
  );
}

SmallArticleBox.propTypes = {
  article: PropTypes.instanceOf(Article).isRequired,
  location: PropTypes.shape({
    article_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    spot_name: PropTypes.string,
  }),
  companyName: PropTypes.string,
};

SmallArticleBox.defaultProps = {
  location: null,
  companyName: null,
};

export default SmallArticleBox;
